import { JiraIcon } from '@atlaskit/logo';
import { whyAmISeeingThisRecommendationMessageDefaultReason } from '@post-office/components--ad-controls';
import { JiraSideNavFirstPartyRecommendation } from '@post-office/components--jira-side-nav-first-party-recommendation';
// @ts-expect-error: 'React' is declared but its value is never read
import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import { createRender } from './types';
import { CCP_PRODUCT_ID, HAMS_PRODUCT_ID, PRODUCT_NAME } from '../../../common/constants';

const whyAmISeeingThisModalContent = {
	message: (
		<p>
			<FormattedMessage
				id="growth.recommendation-jsw-visualize-work.reasons-modal.message"
				defaultMessage="We think {product} will improve your team's productivity. The recommendation is based on:"
				description="Explanation of why we think the Jira recommendation will be relevant to the customer."
				values={{ product: <strong>{PRODUCT_NAME}</strong> }}
			/>
		</p>
	),
	reasons: whyAmISeeingThisRecommendationMessageDefaultReason,
};
export type Props = {
	onDismissed: (messageInstanceId: string) => void;
};
export const render = createRender(({ onDismissed }: Props) => (
	<JiraSideNavFirstPartyRecommendation
		app={{
			hamsIdentifier: HAMS_PRODUCT_ID,
			ccpProductId: CCP_PRODUCT_ID,
			logo: <JiraIcon appearance="brand" />,
			header: (
				<FormattedMessage
					id="growth.recommendation-jsw-visualize-work.product-name.header"
					description="Header for Jira recommendation message in Jira Side Nav"
					defaultMessage="Visualize your projects in lists, boards, and more"
				/>
			),
			ctaMessage: (
				<FormattedMessage
					id="growth.recommendation-jsw-visualize-work.cta.label"
					description="CTA text for Jira recommendation message in Jira Side Nav"
					defaultMessage="Try Jira"
				/>
			),
		}}
		onDismissed={onDismissed}
		whyAmISeeingThisModalContent={whyAmISeeingThisModalContent}
	/>
));
export default render;
